// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("user"); // or your auth check

  return isLoggedIn ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
